import { Component, OnInit } from '@angular/core';
import {Block, BlockAbstractComponent} from '@gallaghercp/core-frontend';

@Component({
    standalone: false,
    selector: 'core-block-header3',
    templateUrl: './block-header3.component.html',
})

export class BlockHeader3Component extends BlockAbstractComponent implements OnInit {

    parseBlockId(block: Block) {
        if (block.data.isAnchor) {
            return this.block.data.text.toLowerCase().replace(/\s+/g, '-');
        } else {
            return 'heading-' + block.id
        }
    }

}
